export default __webpack_public_path__ + "static/media/Camilo.2053ad3c.jpeg";